import type { TFunction } from "i18next";
import MayorActionButton from "./MayorActionButton";

interface MayorActionListProps {
  handleEnterInterior: () => void;
  handleCompleteElection: () => void;
  handleRemoveMayor: () => void;
  setCurrentScreen: (screen: "talk_to_mayor" | "register" | "vote_list" | "mayor_info" | "mayor_role" | "elections_info") => void;
  isLoading: boolean;
  electionActive: boolean | undefined;
  hasMayor: boolean | undefined;
  isAdmin: boolean | undefined;
  t: TFunction;
}

/** Right-aligned town-hall menu: visit office, vote, mayor info, GM tools. */
function MayorActionList({
  handleEnterInterior,
  handleCompleteElection,
  handleRemoveMayor,
  setCurrentScreen,
  isLoading,
  electionActive,
  hasMayor,
  isAdmin,
  t,
}: MayorActionListProps) {
  return (
    <div className="flex flex-col items-end gap-lg">
      <MayorActionButton
        label={t("Visit the mayor's office")}
        onClick={handleEnterInterior}
      />

      <MayorActionButton
        label={t("Talk to the Mayor")}
        onClick={() => setCurrentScreen("talk_to_mayor")}
        emoji="💬"
      />

      <MayorActionButton
        label={t("I want to become the mayor")}
        onClick={() => setCurrentScreen("register")}
      />

      <MayorActionButton
        label={t("I want to vote")}
        onClick={() => setCurrentScreen("vote_list")}
      />

      <MayorActionButton
        label={t("Who is currently the mayor?")}
        onClick={() => setCurrentScreen("mayor_info")}
      />

      <MayorActionButton
        label={t("Tell me about the mayor's role")}
        onClick={() => setCurrentScreen("mayor_role")}
      />

      <MayorActionButton
        label={t("Tell me how the elections work")}
        onClick={() => setCurrentScreen("elections_info")}
      />

      {/* Admin options */}
      {isAdmin === true && (
        <>
          <MayorActionButton
            label="Complete election (GM)"
            onClick={handleCompleteElection}
            disabled={isLoading || !electionActive}
            cursor={isLoading || !electionActive ? "not-allowed" : "pointer"}
            opacity={isLoading || !electionActive ? 0.6 : 1}
          />

          <MayorActionButton
            label="Remove mayor (GM)"
            onClick={handleRemoveMayor}
            disabled={isLoading || !hasMayor}
            cursor={isLoading || !hasMayor ? "not-allowed" : "pointer"}
            opacity={isLoading || !hasMayor ? 0.6 : 1}
          />
        </>
      )}
    </div>
  );
}

export default MayorActionList;
